import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page"
  }, [_c("div", {
    staticClass: "leftBox"
  }, [_c("a-select", {
    staticStyle: {
      width: "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      placeholder: _vm.$t("请选择要查看的客户"),
      "show-search": "",
      "filter-option": _vm.filterOption,
      "option-filter-prop": "children"
    },
    on: {
      change: _vm.customerIdFun
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customerList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "right",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1), _c("a-card", {
    attrs: {
      title: _vm.$t("账号架构"),
      hoverable: false,
      bordered: true
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: _vm.$t("输入关键字进行过滤")
    },
    model: {
      value: _vm.filterText,
      callback: function ($$v) {
        _vm.filterText = $$v;
      },
      expression: "filterText"
    }
  }), _c("div", {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c("a-button", {
    staticStyle: {
      padding: "0"
    },
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.addDepartment(1, null);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("新增部门")))])], 1), _c("el-tree", {
    ref: "tree",
    staticClass: "filter-tree",
    attrs: {
      data: _vm.data,
      props: _vm.defaultProps,
      "default-expand-all": "",
      "filter-node-method": _vm.filterNode,
      "expand-on-click-node": false,
      "highlight-current": true,
      "node-key": "id"
    },
    on: {
      "node-click": _vm.handleNodeClick
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        node,
        data
      }) {
        return _c("span", {
          staticClass: "custom-tree-node"
        }, [_c("a-tooltip", {
          staticClass: "label",
          attrs: {
            placement: "left",
            title: node.label
          }
        }, [_vm._v(" " + _vm._s(node.label) + " ")]), data.id != 0 ? _c("span", {
          staticStyle: {
            display: "flex"
          }
        }, [_c("i", {
          staticClass: "el-icon-circle-plus-outline",
          staticStyle: {
            "font-size": "16px",
            "margin-right": "5px"
          },
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return (() => _vm.addDepartment(node, data)).apply(null, arguments);
            }
          }
        }), _c("i", {
          staticClass: "el-icon-edit-outline",
          staticStyle: {
            "font-size": "16px",
            "margin-right": "5px"
          },
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return (() => _vm.editDepartment(node, data)).apply(null, arguments);
            }
          }
        }), _c("i", {
          staticClass: "el-icon-delete",
          staticStyle: {
            "font-size": "16px"
          },
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return (() => _vm.delDepartment(node, data)).apply(null, arguments);
            }
          }
        })]) : _vm._e()], 1);
      }
    }])
  })], 1)], 1), _c("div", {
    staticClass: "rightBox"
  }, [_c("a-card", {
    attrs: {
      title: _vm.$t("账号列表"),
      hoverable: false,
      bordered: true
    }
  }, [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("账号") + "/" + _vm.$t("管理员名称") + "/" + _vm.$t("手机号"),
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-item", [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("账号状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("已禁用")) + " ")]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("已启用")) + " ")])], 1)], 1), _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: function ($event) {
        return _vm.getaccountTable();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查询")) + " ")])], 1), _c("a-form-item", [_vm.isAuth("home.customerUserStore") ? _c("a-button", {
    staticClass: "select-bottom",
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: function ($event) {
        return _vm.$router.push({
          name: "accountInfo",
          params: {
            id: -1,
            customerId: _vm.form.customerId
          }
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("新增管理员")))]) : _vm._e()], 1)], 1), _c("standard-table", {
    staticClass: "marginT20",
    attrs: {
      tableData: _vm.tableData,
      tableHead: _vm.tableHead,
      loading: _vm.loading,
      bordered: "",
      pagination: _vm.pagination,
      scroll: {
        x: 1500
      }
    },
    on: {
      changeCurrent: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function ({
        index
      }) {
        return _c("div", {}, [_vm._v(" " + _vm._s(index + 1) + " ")]);
      }
    }, {
      key: "status",
      fn: function ({
        text,
        record
      }) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun(record);
            }
          }
        })];
      }
    }, {
      key: "roles",
      fn: function ({
        text,
        record
      }) {
        return [_vm._v(" " + _vm._s(record.isSuper === 1 ? _vm.$t("超级管理员") : text) + " ")];
      }
    }, {
      key: "action",
      fn: function ({
        record
      }) {
        return _c("div", {}, [_vm.isAuth("home.customerUserEdit") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "accountInfo",
                params: {
                  id: record.id,
                  customerId: _vm.form.customerId
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), record.isSuper === 0 && _vm.isAuth("home.customerUserDelete") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleDelete(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e(), _vm.isAuth("home.getTemporaryToken") ? _c("a-button", {
          attrs: {
            type: "primary",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.jumpLogin(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("以此账号登录")))]) : _vm._e()], 1);
      }
    }])
  })], 1)], 1), _vm.departmentDialogVisible ? _c("department-model", {
    ref: "departmentModel",
    on: {
      cancel: function ($event) {
        _vm.departmentDialogVisible = false;
      },
      ok: _vm.getStructure
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };